import get from 'lodash/get';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import { needsOnboarding } from '../helpers/patients';
import {useGetCurrentPatientQuery} from '../redux/services/patientApi';

const useRequirePatientOnboarding = () => {
  const navigate = useNavigate();
  const userQuery = useGetCurrentPatientQuery(null, {skip: false});
  const onboard = needsOnboarding(userQuery?.data);
  const isPatient = get(userQuery, 'data.is_patient', false);
  const isFetching = get(userQuery, 'isFetching', true);
  useEffect(() => {
    if (
      !isFetching
      && isPatient
      && onboard
    ) {
      navigate('/clients/onboarding');
    }
  }, [onboard, isPatient, isFetching, navigate]);
};

export default useRequirePatientOnboarding;
